'use client';

import React from 'react';

import { Column, Columns, Section, Text, Title, TitleLevels, TrilogyColor } from '@bytel/trilogy-react';

import { isFirstLetterVowel } from '@helpers/wording';

export type VideoProps = {
    name: string;
    videoUrl: string;
};

export function Video({ name, videoUrl }: VideoProps) {
    const isNameStartingWithVowel = isFirstLetterVowel(name);
    const title = `${isNameStartingWithVowel ? "L'" : 'Le '}${name} en vidéo`;

    return (
        <>
            <Title level={TitleLevels.FOUR}>{title}</Title>
            <Section backgroundColor={TrilogyColor.BACKGROUND}>
                <Text>
                    Découvrez les points forts et fonctionnalités {isNameStartingWithVowel ? "de l'" : 'du '}
                    {name} avec notre conseiller de vente Bouygues Telecom.
                </Text>
                <Columns>
                    <Column desktopSize={10}>
                        <div style={{ position: 'relative', paddingBottom: '56.25%' }}>
                            <iframe
                                style={{ position: 'absolute', top: 0, left: 0, width: '560', height: '315' }}
                                src={videoUrl}
                                title={title}
                                allow='accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                                allowFullScreen
                                className='is-fullwidth is-fullheight'
                            />
                        </div>
                    </Column>
                </Columns>
            </Section>
        </>
    );
}
